export const PRICE_DESCRIPTIONS = {
  ORIGIN: 'Оригинальная цена',
  VAT: 'Цена без НДС',
};
